import uk from '../JsonLang/uk.json'
export const lang = { ...uk }